export function completesToClick(
  numberOfCompletes: number,
  incidence: number,
): number {
  return Math.round((numberOfCompletes * 100) / incidence);
}
